import React, { createContext, ReactNode, useContext } from "react";
import { MobileAppsMessage, XolaMobileApp } from "types";
import { Message, useXolaMobileAppsBridge } from "@/hooks/useXolaMobileAppsBridge";

interface XolaMobileAppsContextType {
    xolaMobileApp: XolaMobileApp | null;
    isXolaMobileApp: boolean;
    sendMessage: (message: MobileAppsMessage) => void;
    mobileAppMessage: Message | undefined;
}

const XolaMobileAppsContext = createContext<XolaMobileAppsContextType | null>(null);

export const XolaMobileAppsProvider = ({ children }: { children: ReactNode }) => {
    const bridge = useXolaMobileAppsBridge();
    return <XolaMobileAppsContext.Provider value={bridge}>{children}</XolaMobileAppsContext.Provider>;
};

export const useXolaMobileApps = () => {
    const context = useContext(XolaMobileAppsContext);
    if (!context) {
        throw new Error("useXolaMobileApps must be used within XolaMobileAppsProvider");
    }
    return context;
};
